import { createGlobalStyle } from 'styled-components';
import { getFont } from './GlobalStyles.utils';

export const GlobalStyles = createGlobalStyle`
  
@font-face {
  font-family: 'Avenir';
  font-style: normal;
  font-weight: 400;
  font-display: fallback;
  src: ${() => getFont('Avenir-Roman')}
}

@font-face {
  font-family: 'Avenir';
  font-style: normal;
  font-weight: 500;
  font-display: fallback;
  src: ${() => getFont('Avenir-Medium')}
}

@font-face {
  font-family: 'Avenir';
  font-style: normal;
  font-weight: 800;
  font-display: fallback;
  src: ${() => getFont('Avenir-Heavy')}
}

@font-face {
  font-family: 'Avenir';
  font-style: normal;
  font-weight: 900;
  font-display: fallback;
  src: ${() => getFont('Avenir-Black')}
}

  * {
    box-sizing: border-box;
  }

  html {
    scroll-behavior: smooth;
  }

  html,
  body {
    background: #faf9ff;
    margin: 0;
    padding: 0;
    font-family: 'Avenir', sans-serif;
    font-size: 16px;
    -webkit-font-smoothing: antialiased;
    -webkit-text-rendering: optimizeLegibility;
    text-rendering: optimizeLegibility;
  }

  div[class^='_editorRoot_'] {
    z-index: 11;
  }

  #ui-toast-portals {
    z-index: 10;
    position: relative;
  }

  .ui-library-portal-classname {
    position: relative;
    z-index: 9;
  }

  .slick-dots li button:before {
    font-size: 12px !important;
  }

  hr {
    height: 1px;
    width: 100%;
    border: 0;
    background: #DEDCE4;
  }

  a {
    color: ${({ theme }) =>
      theme.palette.schema.brand2.light.ghost.default.foreground};

    &:hover {
      color: ${({ theme }) =>
        theme.palette.schema.brand2.light.ghost.hover.foreground};
    }

    &:focus {
      color: ${({ theme }) =>
        theme.palette.schema.brand2.light.ghost.focus.foreground};
    }

    &:active {
      color: ${({ theme }) =>
        theme.palette.schema.brand2.light.ghost.pressed.foreground};
    };
  }



  #ui-toast-portals {
    z-index: 10;
    position: relative;
  }

  #ui-toast-content {
    position: relative;
    bottom: 2rem;
    right: 2rem;
    max-width: 30rem;
  }

  .markdown-editor form > div {
    display: none !important;
}

  .markdown-editor form > div:first-child,
  .markdown-editor form > div:nth-child(2),
  .markdown-editor form > div:last-child,
  .markdown-editor form[class*="_linkDialogEditForm"] > div {
      display: flex !important;
  }

  .markdown-editor [contenteditable="true"] img {
    max-width: 100%;
  }

  .markdown-editor [role="toolbar"] > span:first-child,
  .markdown-editor [role="toolbar"] > select {
    display: none;
  }

  .markdown-editor [class*="_diffSourceToggle_"] button {
    display: none;
  }

  .markdown-editor [class*="_diffSourceToggle_"] button:nth-child(1),
  .markdown-editor [class*="_diffSourceToggle_"] button:nth-child(3) {
    display: block;
  }
`;
